import { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { useSelectedBundlesReturn, BundleType } from '../../model/bundles.model'
import { setSelectedBundles } from '../../store/bundles.reducer'
import { selectSelectedBundlesIds } from '../../store/bundles.selectors'

import { RootState } from '~/core/store/root.reducer'
import { selectBundlesWithFormattedPrice } from '~/prices/prices.selectors'

export default function useSelectedBundles(
  lineId: string,
  type: BundleType,
): useSelectedBundlesReturn {
  const dispatch = useDispatch()

  const selectedBundles = useSelector((state: RootState) =>
    selectBundlesWithFormattedPrice(state, lineId, type),
  )

  const selectedBundlesIds = useSelector((state: RootState) =>
    selectSelectedBundlesIds(state, lineId, type),
  )

  const onDeleteBundle = useCallback(
    (id: number) => {
      const bundles = selectedBundlesIds.filter((bundle) => bundle !== id)
      dispatch(setSelectedBundles({ id: lineId, bundles, type }))
    },
    [selectedBundles],
  )

  return { selectedBundles, onDeleteBundle }
}
